<template>
  <section class="web-content-page">
    <h1>       <font-awesome-icon
      icon="headset"
      class="pointer"
    /> <span class="header-margin">All Agents</span></h1>
    <div class="main-container">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick">
        <el-tab-pane
          label="Handled Policies"
          name="handled"></el-tab-pane>
      </el-tabs>

      <div class="filter-container">
        <div class="flex">
          <div class="filter-box">
            <div class="search-box">
              <v-date-picker
                v-model="date"
                type="daterange"
                @change="filterData"/>
            </div>
          </div>
          <div class="flex-content-button">
            <v-radio-group
              v-model="selectData"
              :border="true"
              :button="true"
              :list="yesNoOption" />
            <v-button
              type="primary"
              class="button-margin"
              plain
              icon="el-icon-download"
              @click="onDownload">
              Download PDF</v-button>
          </div>
        </div>
      </div>

      <div class="transparent-block">
        <el-table
          :data="tableData"
          style="width: 100%"
          :header-row-class-name="'tableHeader'"
        >
          <el-table-column
            prop="email"
            label="Agent">
            <template #default="{ row }">
              <span class="action-title">{{ row.email }}</span><br>
              <span v-if="row.email">{{ row.email }}</span><br  v-if="row.email">
            </template>

          </el-table-column>
          <el-table-column
            prop="created_date"
            label="Policy">
            <template #default="{ row }">
              <span class="span-title">{{ row.created_date }}</span><br>
              <span v-if="row.created_date">{{ row.created_date }}</span><br  v-if="row.created_date">
              <span
                v-if="row.created_date"
                class="span-title">{{ row.created_date }}</span><br  v-if="row.created_date">
            </template>
          </el-table-column>
          <el-table-column
            prop="status_language"
            label="Payment">
            <template #default="{ row }">
              <span class="span-title">{{ row.status_language }}</span><br>
              <span v-if="row.status_language">{{ row.status_language }}</span><br  v-if="row.status_language">
              <span
                v-if="row.status_language"
                class="span-title">{{ row.status_language }}</span><br  v-if="row.status_language">
            </template>
          </el-table-column>
        </el-table>
      </div>

      <v-pagination
        :total="pageConfig.total"
        :current="pageConfig.currentPage"
        @currentChange="currentChange"/>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import { getNesLetterList,unsubscribe,resubscribe } from '@/api/newsletter'
import {downloadChequeList} from '@api/cheque'
export default {
  name: 'accountAuditDetail',
  mixins: [MixinOptions],
  data() {
    return {
      date:[],
      activeName:'handled',
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      search: '',
      tableData: [],
      selectData:1,
      yesNoOption: [
        {
          name: 'Week',
          id: 0
        },
        {
          name: 'Month',
          id: 1
        },
        {
          name: 'Year',
          id: 2
        },
        {
          name: 'Customer',
          id: 3
        }
      ],
    }
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        this.network().getNesLetterList()
      }
    }
  },
  methods: {
    handleClick(){

    },
    rowClick(row) {
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getNesLetterList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getNesLetterList()
    },
    onDownload() {
      this.network().downloadChequeList()
    },
    network() {
      return {
        getNesLetterList: async () => {
          const { data } = await getNesLetterList({
            search: this.search,
            page: this.pageConfig.currentPage
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
        downloadChequeList: async () => {
          const res = await downloadChequeList({
            status: this.status,
            page: this.pageConfig.currentPage
          })
          const blob = new Blob([res.data])
          const contentDisposition = res.headers['Content-Disposition'] || res.headers['content-disposition']
          const patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
          const fileName = patt.exec(contentDisposition)[1]
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = window.URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          window.URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.web-content-page {
  position: relative;
  h1 {
    padding-bottom: 15px;
    color: #616266;
    font-size: 20px;
    .header-margin{
      margin-left: 15px;
    }
  }
  .inline-input{
    display: flex;
    align-items: center;
    .to-span{
      margin: 0 10px;
    }
  }
  .transparent-block{
    border: 1px solid #E1E4E8;
    //border-bottom: 0;
    border-radius: 5px;
  }
  ::v-deep .tableHeader{
    background: #E1E4E8!important;
    color: #24292E;
    th{
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      /* Text/text-gray-dark */
      color: #24292E!important;
    }

  }
  .name-title{
    color: #24292E;
    font-weight: bold;
  }
  .action-title{
    color: #24292E;
    font-weight: 500;
  }
  .span-title{
    color: #24292E;
    font-family: Inter;
    font-size: 12px;
  }
  .flex{
    margin-bottom: 10px;
    justify-content: space-between;
    align-items: center;
    .flex-content-button{
      display: flex;
      align-items: center;margin-bottom: 10px;
      .button-margin{
        margin-left: 15px;
      }
    }
  }

}
</style>
